module.exports = __webpack_public_path__ + "img/bj-dt-3.6f50d964.jpeg";